import React, { useState, useRef, useEffect } from "react";
import './CreateOrganization.css';
import { createNewOrganization } from "../../../../api/organization";
import { useNavigate } from "react-router-dom";
import { auth } from '../../../../FirebaseConfig';
import Toast from "../../../common/Toast";
import { Spinner } from 'react-bootstrap';


const CreateOrganization = () => {
  const [name, setName] = useState("");
  const [logo, setLogo] = useState(null);
  const [description, setDescription] = useState("");
  const [color, setColor] = useState("#000000");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);


  // Ref for file input to reset it
  const fileInputRef = useRef(null);

  // Handle changes in logo
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;

        // Save the image to localStorage with the organization name as the key
        if (name) {
          localStorage.setItem(name + "_logo", base64String);
        }

        // Update the state with the image
        setLogo(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  // Remove logo from localStorage
  const handleDeleteLogo = () => {
    if (name) {
      localStorage.removeItem(name + "_logo");
    }
    setLogo(null);
    fileInputRef.current.value = ""; 
  };

  useEffect(() => {
    if (name && !logo) {
      // Retrieve the saved logo from localStorage
      const savedLogo = localStorage.getItem(name + "_logo");
      if (savedLogo) {
        setLogo(savedLogo);
      }
    }
  }, [name, logo]);

  useEffect(()=>{
    const currentUser = auth.currentUser; 
    if(window.Cypress) {
      setUser({ uid: 'test-user', email: 'test@example.com'})
    } else if(currentUser){
      setUser(currentUser)
    }
    setIsLoading(false);
  },[])
  

  const handleAddOrg = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    // Get the logo from state (Base64 string)
    const logoUrl = logo || null;

    // Create organization object
    let organizationData = {
      name,
      description,
      brandColor: color,
      ...(logoUrl && { logoImg: logoUrl }),
    };

    try {
      await createNewOrganization(organizationData);
      setIsModalOpen(true);

      // Remove logo from localStorage
      if (name) {
        localStorage.removeItem(name + "_logo");
      }

      // Reset form fields
      setName("");
      setDescription("");
      setColor("#000000");
      setLogo(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error creating organization:", error);
      alert("Failed to create organization. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="spinnerWrapper">
        <Spinner animation="border" className="customSpinner" />
          <span>Loading Page...</span>
      </div>
    );
  }
  if(!user){
    return(
      <Toast
      title="Temporary warning!"
      subTitle="Please sign up to work on this page."
    />
    )
  }

  return (
    <div>
      <h4>Create Organization</h4>
      <div className="org-container">
        <form onSubmit={handleAddOrg} className="input-container">
          <div>
            <label>Organization Name <span style={{ color: 'red' }}>*</span></label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter name"
              required
            />
          </div>
          <div>
            <label htmlFor="logo-upload" className="file-label">Choose Logo </label>
            <input 
              type="file" 
              accept="image/*" 
              onChange={handleFileChange} 
              ref={fileInputRef}
            />
            {/* Display the uploaded image */}
            {logo && <img src={logo} alt="Organization Logo" width="100" height="100" />}
            
            {/* Remove logo button */}
            {logo && (
              <button onClick={handleDeleteLogo} className="delete-btn">
                Remove Logo
              </button>
            )}
          </div>

          <div>
            <label>Organization Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Description"
              rows="4"
              cols="54"
            ></textarea>
          </div>

          <button type="submit" className="button" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Create Organization"}
          </button>
        </form>
      </div>     
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Success</h2>
            <p>Organization created successfully!</p>
            <button onClick={() => navigate("/dashboard/organizations-list")} className="button">OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateOrganization;
